import React, { useState, useEffect } from "react";
import useHttp from "../../hooks/use-http";
import { toast } from "react-toastify";
import { utils, read } from "xlsx";
import ReactFileReader from "react-file-reader";
import Pagination from "../../components/Pagination";
import moment from "moment";

const EmployeeUpload = () => {
  const [data, setData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [formData, setFormData] = useState();
  const [areaData, setAreaData] = useState([]);  
  const [departmentData, setDepartmentData] = useState([]);  
  const [designationData, setDesignationData] = useState([]);  

  
  const [regionData, setRegionData] = useState([]);
  var d = new Date();
  var dateString =
    d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();


  
  const {

      sendRequest: getArea,
    } = useHttp();
  



  const {

    sendRequest: getRegion,
  } = useHttp();

  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      
      }
    );
  }, [getRegion]);

  useEffect(() => {
      getArea(
        {
          url: `/api/areaDetails/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          //console.log("region", data);
  
          setAreaData(data);
        
        }
      );
    }, [getArea]);
  

    const {

      sendRequest: getDesignation,
    } = useHttp();

    
    useEffect(() => {
      getDesignation(
        {
          url: `/api/designation/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          // console.log(data);
          setDesignationData(data);
        }
      );
    }, [getDesignation]);


    const {

      sendRequest: getDepartment,
    } = useHttp();

    useEffect(() => {
      getDepartment(
        {
          url: `/api/department/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          //console.log(data);
          setDepartmentData(data);
        }
      );
    }, [getDepartment]);
  

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData1 = utils.sheet_to_json(worksheet, { header: 1 });
    
    const parsedData=parsedData1.filter(item=>item[0]!="");
    console.log(parsedData);
    setData(parsedData);
   
    const headers = parsedData[0];
     
    const jsonData = parsedData.slice(1).map((row,index) => {
      //console.log(index)
    

      const reportingEmployeeName = row[headers.indexOf("Reporting Employee")];
      const areaName = row[headers.indexOf("Area Name")];
      const regionName= row[headers.indexOf("Region Name")];

      const designationName= row[headers.indexOf("Designation")];
      const departmentName= row[headers.indexOf("Department")];

      const reportingEmployee = employeeData.find(
        (employee) => employee.employeeName === reportingEmployeeName
      );

     

      const regionobj = regionData.find(
        (regionitem) => regionitem.regionName === regionName
      );

      
      const areaobj = areaData.find(
        (areaitem) => areaitem.areaName === areaName
      );

      const departmentobj = departmentData.find(
        (departmentitem) => departmentitem.departmentName === departmentName
      );

      const designationobj = designationData.find(
        (designationitem) => designationitem.designationName === designationName
      );

      console.log("designationName",designationName)
      console.log("designationobj",designationobj)
      var bdate=row[headers.indexOf("Birth Date")]
      var jdate=row[headers.indexOf("Date of Joining")]
      
      let birth_date = new Date(Math.round((bdate - 25569) * 864e5));
      birth_date = moment(birth_date).format('DD/MM/YYYY')
      console.log("birth_date",birth_date) 

      let joining_date = new Date(Math.round((jdate - 25569) * 864e5));
      joining_date = moment(joining_date).format('DD/MM/YYYY')
      console.log("joining_date",joining_date) 
       

      const employee = {
        employeeName: row[headers.indexOf("Employee Name")],
        orgId: localStorage.getItem("orgId"),
        createdDate: dateString,
        gender: row[headers.indexOf("Gender")],
        emailId:row[headers.indexOf("Email id")],
        areaId :areaobj ? areaobj.areaId : null,
        areaName :areaName,
        regionId :regionobj ? regionobj.regionId : null,
        designationId :designationobj ? designationobj.designationId : null,
        departmentId :departmentobj ? departmentobj.departmentId : null,
        regionName :regionName,
        whatsappNo: row[headers.indexOf("Whatsapp Number")],
        contactNo: row[headers.indexOf("Contact Number")],
        birthDate:  birth_date ,
        dateofJoining: joining_date,
        designationName: row[headers.indexOf("Designation")],
        departmentName: row[headers.indexOf("Department")],
        employeeType: row[headers.indexOf("Employee Type")],
        employmentType: row[headers.indexOf("Employment Type")],
        grossSalary: row[headers.indexOf("Gross Salary")],
        perDaySalary: row[headers.indexOf("Per Day Wages")],
        warehouseName: row[headers.indexOf("Location")],
        reportingId: reportingEmployee ? reportingEmployee.empId : null,
        workContactNo: row[headers.indexOf("work Contact Number")],
        workEmailId: row[headers.indexOf("Work Email")],
        createdBy: parseInt(localStorage.getItem("id")),
        profileurl: parseInt(localStorage.getItem("Profile Image")),
        idProof: row[headers.indexOf("ID Proof")],
        userName: row[headers.indexOf("User Name")],
        password: row[headers.indexOf("Password")],
        useCase: row[headers.indexOf("Use Case")],

        	


        address: [
          {
            srno: 1,
            addressType: "Permanent",
            landmark: row[headers.indexOf("Permanent Address")],
            lga: row[headers.indexOf("Permanent LGA")],
            city: row[headers.indexOf("Permanent City")],
            state: row[headers.indexOf("Permanent State")],
            zipcode: row[headers.indexOf("Permanent Zip Code")],
            country: row[headers.indexOf("Permanent Country")],
            lat: row[headers.indexOf("Permanent Lat")],
            lng: row[headers.indexOf("Permanent Long")],
          },
          {
            srno: 2,
            addressType: "Residential",
            landmark: row[headers.indexOf("Residential Address")],
            lga: row[headers.indexOf("Residential LGA")],
            city: row[headers.indexOf("Residential City")],
            state: row[headers.indexOf("Residential State")],
            zipcode: row[headers.indexOf("Residential Zip Code")],
            country: row[headers.indexOf("Residential Country")],
            lat: row[headers.indexOf("Residential Lat")],
            lng: row[headers.indexOf("Residential Long")],
          },
        ],

        bankDetail: [
          {
            srno: 1,
            accountNumber: row[headers.indexOf("Account Number")],
            accountHolderName: row[headers.indexOf("Acc Holder Name")],
            ifscCode: row[headers.indexOf("IFSC Code")],
          },
        ],

        createdBy: parseInt(localStorage.getItem("id")),
      };

      return employee;
    });
    console.log(jsonData);

    
    setFormData(jsonData);
  };

  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: postAddEmployee } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    postAddEmployee(
      {
        url: "/api/employeeUplaod/",
        method: "POST",
        body: formData,
      },
      (data) => {
        toast.success(`Employee Added  successfully`);
        setFormData("");
        setData("");
      }
    );
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">&nbsp;
                <form onSubmit={submitHandler}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-10">   <label className="card-title mx-2 my-3 ">
                          Employee Details
                        </label></div>

                        <div className="col-2">
                          <ReactFileReader
                            handleFiles={handleFileUpload}
                            fileTypes={".xlsx"}
                          >
                            <button
                              type="button"
                              className="btn  btn-primary mx-2 my-2"
                            >
                              Upload Excel
                            </button>
                          </ReactFileReader>{" "}
                        </div>
                      </div>

                      <div className="row">
                        <table className="table table-bordered table-responsive text-center table-sm">
                          <thead>
                            <tr className="tableheaderrowview">
                              {data[0] &&
                                data[0].map((header, index) => (
                                  <th key={index}>{header}</th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data &&
                              data.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                  ))}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* /.card-body */}
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>

                  <div className="text-center">
                    <button className="btn  btn-primary mx-2 my-2" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EmployeeUpload;
